const config = {
  stage: window.STAGE,
  publicPath: window.PUBLIC_PATH,
  amplitude: {
    apiKey: window.AMPLITUDE_API_KEY,
  },
  sentry: {
    dsn: window.SENTRY_DSN,
    release: process.env.SENTRY_RELEASE,
  },
  amtrak: {
    url: window.AMTRAK_URL,
    oryUrl: window.AMTRAK_ORY_URL,
    apiUrl: window.AMTRAK_API_URL,
    whitelabelUrl: window.AMTRAK_WHITELABEL_URL,
    signupFormUrl: window.AMTRAK_SIGNUP_FORM_URL,
  },
  distribusion: {
    url: window.DISTRIBUSION_URL,
    oryUrl: window.DISTRIBUSION_ORY_URL,
    apiUrl: window.DISTRIBUSION_API_URL,
    whitelabelUrl: window.DISTRIBUSION_WHITELABEL_URL,
    commonApiUrl: window.DISTRIBUSION_GENERAL_API_URL,
    whitelabelTranslationsApiUrl: window.DISTRIBUSION_WHITELABEL_TRANSLATIONS_API_URL,
  },
  partnerManagement: {
    apiUrl: window.PARTNER_MANAGEMENT_API_URL,
  },
  userManagement: {
    apiUrl: window.USER_MANAGEMENT_API_URL,
  },
  oryOidcProviderIds: {
    google: 'google',
    amadeus: window.ORY_OIDC_PROVIDER_ID_AMADEUS,
  },
  featureFlags: {
    debug: window.FF_DEBUG,
    mockRequests: window.FF_MOCK_REQUESTS,
    betaFeaturesForInternals: window.FF_BETA_FEATURES_FOR_INTERNALS,
    newOryUI: window.FF_NEW_ORY_UI,
    financialDocuments: window.FF_FINANCIAL_DOCUMENTS,
    lockStateToConfig: window.FF_LOCK_STATE_TO_CONFIG,
  },
};

export default config;
